import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Loader, Toastr, Button } from "@revvsales/components";

import Modal from "react-responsive-modal";
import { FilePond } from "react-filepond";
import { DOCUMENTS, EVENTS } from "../../../constants";
import "filepond/dist/filepond.min.css";
import StatusDropdown from "../StatusDropdown";

// Actions Imports

// Service Imports
import {
  uploadRawQuoteDocument,
  uploadRevisedDocument,
} from "../../../actions/QuoteDocuments/services";

import {
  updateMultipleDocumentSections,
  deleteDocumentComponentService,
} from "../../../actions/DocumentActions/services";

import { fetchDocumentByDocNo } from "../../../actions/QuotationActions/QuotationServices";

import {
  getInitData,
  clearDocumentDetails,
  updateToolPaneData,
} from "../../../actions/QuotationActions/QuotationActions";

// Internal Imports
import { AmplitudeUtils } from "../../../utils/index";
import {
  modifyDocumentContent,
  modifyDocumentSection,
} from "../../../utils/documentUtils";

import { createDocumentRevision } from "../../../utils/quotationUtils";

import CreateDocumentNotes from "../../RevvEditor/createDocumentNotes";

import DocumentView from "./DocumentView";
// Destructuring
const { DOCX_FILETYPE } = DOCUMENTS;
// Destructuring

class UploadDocument extends Component {
  state = {
    documentDetails: [],
    uploadStatus: null,
    fileDetails: { name: null, size: 0 },
    errMsg: "",
    file: null,
  };

  _isDocxFile = fileItems => {
    const isWindowsOs = navigator.platform.indexOf("Win") > -1;
    if (isWindowsOs) {
      return !(
        fileItems[0].fileExtension === "docx" && fileItems[0].fileType === ""
      );
    }
    return (
      fileItems[0].fileExtension !== "docx" ||
      fileItems[0].fileType !== DOCX_FILETYPE
    );
  };

  _uploadDocument = fileItems => {
    if (Object.keys(fileItems).length !== 0) {
      if (this._isDocxFile(fileItems)) {
        this.setState({
          uploadStatus: null,
          errMsg: "Only .docx files are supported",
        });
        return;
      }
      if (
        !(
          fileItems[0].filename === this.state.fileDetails.name &&
          fileItems[0].fileSize === this.state.fileDetails.size
        )
      ) {
        const fileDetails = {
          name: fileItems[0].filename,
          size: fileItems[0].fileSize,
        };
        const { file } = fileItems[0];
        this.setState({
          uploadStatus: "Uploading",
          fileDetails,
          errMsg: "",
          file,
        });
        this._getDocumentSections(file);
        // return;
      }
    } else {
      const fileDetails = { name: null, size: 0 };
      this.setState({
        uploadStatus: null,
        fileDetails,
        errMsg: "",
        file: null,
      });
    }
  };

  _getDocumentSections = fileDetails => {
    uploadRawQuoteDocument(fileDetails)
      .then(response => {
        const documentSections = modifyDocumentContent(
          response,
          "UPLOADED_DOCUMENT",
        );
        this.setState({
          uploadStatus: "done",
          documentDetails: documentSections,
        });
      })
      .catch(error => {
        this.setState({
          uploadStatus: null,
          errMsg: `Invalid content in the file. Error encountered. ${
            error.message
          }`,
        });
      });
  };

  _closePreviewModal = () => {
    this.props.closePopup();
  };

  _getCurrentDocumentView = () => {
    const {
      content: { sections },
    } = this.props;
    const sectionList = createDocumentRevision(sections).map(section => {
      const { content } = section;
      return {
        ...content,
        id: content.section_id || content.id,
        type: content.section_type || content.type,
        label: content.section_name || content.label,
      };
    });
    return <DocumentView sectionList={sectionList} mode="PREVIEW" />;
  };

  _getUploadedDocumentView = () => (
    <DocumentView
      sectionList={this.state.documentDetails.sections}
      mode="UPLOADED_DOCUMENT"
    />
  );

  _createNotes = documentDetails => {
    const { components, id, doc_no: docNo } = documentDetails;
    let createdNotes = [];
    const notes = new CreateDocumentNotes({
      id,
      components,
      mode: "UPLOADED_DOCUMENT",
    });
    createdNotes = notes.create();
    const commentSection =
      components &&
      components.find(section => section.content.section_type === "Comments");
    if (commentSection) {
      deleteDocumentComponentService(docNo, commentSection);
    }
    return createdNotes;
  };

  _updateSections = (documentDetails, createdNotes) => {
    const { components } = documentDetails;
    const updatedSectionIDs = [];
    // if notes are created, then getting the updated sections
    if (createdNotes) {
      createdNotes.forEach(note => {
        const {
          anchor: { component_id: sectionId },
        } = note;
        if (updatedSectionIDs.findIndex(sec => sec === sectionId) === -1) {
          updatedSectionIDs.push(sectionId);
        }
      });
    }
    // if sections are updated, update according to uploaded document mode
    const updatedSections = updatedSectionIDs.map(sectionID => {
      const section = components.find(sec => sec.component_id === sectionID);
      return modifyDocumentSection(section.content, "UPLOADED_DOCUMENT");
    });

    return updatedSections;
  };

  _getNewDocumentData = (id, docNo) => {
    fetchDocumentByDocNo(docNo)
      .then(res => {
        // Now call the below action to fetch dealtable column and row data
        this.props
          .getInitData(id, res)
          .then(() => {
            this.props.closePopup();

            AmplitudeUtils.amplitudeLogEvent(
              EVENTS.EVENT_NAMES.REVISION_UPLOADED,
              {
                ...this.props.document,
              },
            );
          })
          .catch(error => {
            this.props.closePopup();
            console.debug(
              `Error while converting new revsion. Error: ${error.message}`,
            );
          });
      })
      .catch(error => {
        this.props.closePopup();
        console.debug(
          `Error while creating new revsion. Error: ${error.message}`,
        );
      });
  };

  _updateDocument = () => {
    const { file } = this.state;
    const {
      document: { docNo, name },
    } = this.props;
    if (file === null) {
      this.setState({
        errMsg: "Only .docx files are supported",
      });
      return;
    }

    // chnaging the uploading status
    this.setState({ uploadStatus: "Creating new version of document" });

    // creating a new revsion of the document
    uploadRevisedDocument(file, name, docNo)
      .then(response => {
        // updating the upload status
        this.setState({
          uploadStatus: "New version available. Calculating the changes",
        });
        const { id } = response;

        // getting the components and checking if there is any comments or diff in it or not.
        const createdNotes = this._createNotes(response);
        const updatedSections = this._updateSections(response, createdNotes);

        // update the sections in backend
        updateMultipleDocumentSections(updatedSections).then(() => {
          // remove old document data, and fecting new documnent and then redirecting
          this.props.clearDocumentDetails();
          this._getNewDocumentData(id, docNo);
          // Initially call the document API to fetch the document data
        });
        this.setState({ uploadStatus: "done" });
      })
      .catch(error => {
        this.props.closePopup();
        console.debug(
          `Error while creating new revsion. Error: ${error.message}`,
        );
        this._showMessage(
          `Error while creating new revsion. Error: ${error.message}`,
        );
      });
  };

  _showMessage = (message, failure) => {
    Toastr.showToastr({
      className: failure ? "is-failure" : "success",
      message,
      timeout: 6000,
    });
  };

  render() {
    const { uploadStatus, errMsg } = this.state;
    let uploadView;
    let errSpace = null;
    if (errMsg) {
      errSpace = (
        <div className="error-message-wrapper">
          <span className="error-message-icon">
            <FontAwesomeIcon icon={["far", "times-circle"]} />
          </span>
          {errMsg}
        </div>
      );
    }
    if (!uploadStatus) {
      uploadView = (
        <Modal
          open
          className="upload-document-new-version"
          onClose={this._closePreviewModal}
          closeOnOverlayClick={false}
          center>
          {errSpace}
          <div className="createdoc-title">
            Upload third party revision documents
          </div>
          <FilePond
            allowMultiple={false}
            onupdatefiles={this._uploadDocument}
            labelIdle="Drag & drop .docx files or <u>browse</u> to upload"
          />
          <div className="createdoc-title" />
          <div className="uploadrevision-popup-docstatus-wrapper">
            <div className="doc-status-lable">
              <span>Also update document status to</span>
            </div>
            <div className="doc-status-select">
              <StatusDropdown
                currentStatus={this.props.document.documentStatus}
                docId={this.props.document.id}
                source="Popup"
              />
            </div>
          </div>

          <section className="createquotepopup-footer popup-footer clearfix">
            <div className="footer-actions">
              <Fragment>
                <Button
                  className="revv-btn-secondary"
                  data-test="analysispopup-no-approval-ok-btn"
                  id="approvalpopup-no-approval-ok-btn"
                  onClick={this._closePreviewModal}>
                  Cancel
                </Button>
                <Button
                  className="btn btn-primary"
                  data-test="analysispopup-no-approval-ok-btn"
                  id="approvalpopup-no-approval-ok-btn"
                  onClick={() => this._updateDocument()}>
                  Upload and continue
                </Button>
              </Fragment>
            </div>
          </section>
        </Modal>
      );
    } else if (uploadStatus && uploadStatus !== "done") {
      uploadView = (
        <Loader
          className="saving-document"
          label={uploadStatus}
          fullScreen
          theme="dark"
        />
      );
    } else if (uploadStatus && uploadStatus === "done") {
      const currentDocView = this._getCurrentDocumentView();
      const uploadedDocView = this._getUploadedDocumentView();
      uploadView = (
        <div className="compare-document">
          <div className="compare-document-header">
            Quick Preview
            <div className="document-confirm-changes">
              <Button
                onClick={() => this._closePreviewModal()}
                className="revv-btn-secondary"
                data-test="uploaddocument-discard-btn">
                Discard
              </Button>
              <Button
                onClick={() => this._updateDocument()}
                data-test="uploaddocument-edit-btn">
                Continue to edit
              </Button>
            </div>
          </div>

          <div className="document-compare-box">
            <div className="document-current">
              <div className="document-current-heading">Current Version</div>
              <div className="document-current-view">{currentDocView}</div>
            </div>
            <div className="document-uploaded">
              <div className="document-uploaded-heading">Uploaded Document</div>
              <div className="document-uploaded-view">{uploadedDocView}</div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <Modal
        classNames={{ modal: "doc-compare-modal" }}
        open
        onClose={this._closePreviewModal}
        showCloseIcon={false}
        closeOnOverlayClick={false}
        center>
        {uploadView}
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const { document, content } = state.DocumentStore;
  const { dealTableId } = state.QuotationStore;
  const { rowData: rowDataObj = {}, metaData } = state.DealTableStore;

  // Pick out the required data from redux
  const rowData = rowDataObj[dealTableId] || [];

  return {
    content,
    document,
    metaData,
    rowData,
  };
};

const mapDispatchToProps = {
  getInitData,
  clearDocumentDetails,
  updateToolPaneData,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(UploadDocument));



// WEBPACK FOOTER //
// ./src/components/QuotationTopbar/QuotationTopbarBtns/UploadDocument.js